// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__s8ymF","copy":"styles_copy__6eOVK"};